import { render } from "./ProjectCards.vue?vue&type=template&id=1a1c7146"
import script from "./ProjectCards.vue?vue&type=script&lang=js"
export * from "./ProjectCards.vue?vue&type=script&lang=js"
script.render = render

export default script